import React from 'react';
import { List, ListItem, Box, Text } from '@chakra-ui/react';
import { Link, useMatch } from 'react-router-dom';

export default function ExperimentsNavigation({ expandedNavBar }: { expandedNavBar: boolean }) {
	const samplesSelected = useMatch('/ai-experiments/samples');
	const templatesSelected = useMatch('/ai-experiments/templates');
	const testsSelected = useMatch('/ai-experiments/tests');

	return (
		<List position="relative" display={expandedNavBar ? 'block' : 'none'} marginTop="10px">
			<ListItem height="2em" position="relative">
				<Box
					borderBottom="1px solid #D5DDE4"
					width="15px"
					borderBottomLeftRadius="6px"
					position="absolute"
					height="1em"
					borderLeft="1px solid #D5DDE4"
				/>
				<Link
					to="/ai-experiments/samples"
					aria-current={samplesSelected ? 'page' : undefined}
				>
					<Text
						_hover={{ background: '#F0F3F6' }}
						marginLeft="20px"
						padding="5px"
						fontSize="14px"
						borderRadius="9px"
						fontWeight={500}
						cursor="pointer"
						background={samplesSelected ? '#F0F3F6' : 'none'}
						textDecoration={samplesSelected ? 'underline' : undefined}
					>
						Samples
					</Text>
				</Link>
			</ListItem>
			<ListItem height="2em" position="relative">
				<Box
					borderBottom="1px solid #D5DDE4"
					width="15px"
					borderBottomLeftRadius="6px"
					position="absolute"
					height="1em"
					borderLeft="1px solid #D5DDE4"
				/>
				<Link
					to="/ai-experiments/templates"
					aria-current={templatesSelected ? 'page' : undefined}
				>
					<Text
						_hover={{ background: '#F0F3F6' }}
						marginLeft="20px"
						padding="5px"
						fontSize="14px"
						borderRadius="9px"
						fontWeight={500}
						cursor="pointer"
						background={templatesSelected ? '#F0F3F6' : 'none'}
						textDecoration={templatesSelected ? 'underline' : undefined}
					>
						Templates
					</Text>
				</Link>
			</ListItem>
			<ListItem height="2em" position="relative">
				<Box
					borderBottom="1px solid #D5DDE4"
					width="15px"
					borderBottomLeftRadius="6px"
					position="absolute"
					height="1em"
					borderLeft="1px solid #D5DDE4"
				/>
				<Link to="/ai-experiments/tests" aria-current={testsSelected ? 'page' : undefined}>
					<Text
						_hover={{ background: '#F0F3F6' }}
						marginLeft="20px"
						padding="5px"
						fontSize="14px"
						borderRadius="9px"
						fontWeight={500}
						cursor="pointer"
						background={testsSelected ? '#F0F3F6' : 'none'}
						textDecoration={testsSelected ? 'underline' : undefined}
					>
						Tests
					</Text>
				</Link>
			</ListItem>
		</List>
	);
}
